import { useSession } from "@core/hooks/useSession";
import { api } from "@core/services/nocd-api";
import { useQuery, UseQueryResult } from "react-query";

import { DiscoverFeedPost } from "../types";

export const getPrivateDiscoverFeedQueryKey = (accessToken: string) =>
  ["community-discover-feed", accessToken] as const;

const usePrivateDiscoverFeed = (): UseQueryResult<
  { posts: DiscoverFeedPost[] },
  Error
> => {
  const { data: session } = useSession();

  return useQuery(
    getPrivateDiscoverFeedQueryKey(session?.accessToken),
    ({ signal }) =>
      api
        .get<{ posts: DiscoverFeedPost[] }>("/v1/community/discover_feed", {
          signal,
          headers: {
            Authorization: session?.accessToken,
          },
        })
        .then(({ data }) => data),
    {
      staleTime: Infinity,
      enabled: !!session?.accessToken,
    }
  );
};

export default usePrivateDiscoverFeed;
